import { useMemo } from 'react'
import {
  MilestoneDetail,
  MilestoneScope,
} from '../../../../domain/entity/MilestoneEntity'
import { ProjectPlanNewRow, NewWbsItemRow } from '../projectPlanNew'

const EMPTY_SCOPE: MilestoneScope = {
  rootMilestones: [],
  descendantMilestonesByWbsItemUuid: new Map(),
}

export const classifyMilestones = (
  data: ProjectPlanNewRow[],
  milestones: MilestoneDetail[],
  rootWbsItem: NewWbsItemRow | undefined,
  isWbsItemTargetEnabled: boolean
): MilestoneScope => {
  if (!milestones.length) return EMPTY_SCOPE

  // 対象を設定できない場合、マイルストーンは全てプロジェクト全体のものとして
  // ガントヘッダーに表示する(対象機能の導入前と同じ表示)。
  if (!isWbsItemTargetEnabled) {
    return {
      rootMilestones: milestones,
      descendantMilestonesByWbsItemUuid: new Map(),
    }
  }

  const rowByWbsItemUuid = new Map<string, ProjectPlanNewRow>()
  data.forEach(row => {
    if (row.wbsItemUuid) rowByWbsItemUuid.set(row.wbsItemUuid, row)
  })

  const rootMilestones: MilestoneDetail[] = []
  const descendantMilestonesByWbsItemUuid = new Map<string, MilestoneDetail[]>()
  const rootWbsItemUuid = rootWbsItem?.uuid

  for (const milestone of milestones) {
    if (!milestone.wbsItemUuid) {
      if (!rootWbsItemUuid) {
        rootMilestones.push(milestone)
      }
      continue
    }

    if (rootWbsItemUuid && milestone.wbsItemUuid === rootWbsItemUuid) {
      rootMilestones.push(milestone)
      continue
    }

    if (rootWbsItemUuid) continue

    const ownerRow = rowByWbsItemUuid.get(milestone.wbsItemUuid)
    if (!ownerRow) continue

    const list =
      descendantMilestonesByWbsItemUuid.get(ownerRow.wbsItemUuid) ?? []
    list.push(milestone)
    descendantMilestonesByWbsItemUuid.set(ownerRow.wbsItemUuid, list)
  }

  return {
    rootMilestones,
    descendantMilestonesByWbsItemUuid,
  }
}

export const useMilestoneScope = (
  data: ProjectPlanNewRow[],
  milestones: MilestoneDetail[],
  rootWbsItem: NewWbsItemRow | undefined,
  isWbsItemTargetEnabled: boolean
): MilestoneScope =>
  useMemo(
    () =>
      classifyMilestones(data, milestones, rootWbsItem, isWbsItemTargetEnabled),
    [data, milestones, rootWbsItem, isWbsItemTargetEnabled]
  )
